
import { LocalDataTrack } from 'twilio-video';
import { useCallback } from 'react';
import useVideoContext from '../useVideoContext/useVideoContext';

export default function useSendMessage() {
    const { localTracks } = useVideoContext();
    const dataTrack = localTracks.find(track => track.kind === 'data') as LocalDataTrack;

    const sendMessage = useCallback((msgType:string, userSid: string) => {
        if (dataTrack) {
            dataTrack.send(
                JSON.stringify({
                    type: msgType,
                    sid: userSid,
                })
            );
        }
    }, [dataTrack]);

    return [sendMessage] as const;
}
